import React from "react"

import Index from "../components/pages/topics.js"

const IndexPage = () => (
  <Index lang="pl" />
)

export default IndexPage
